const initialState = {
    isAPIResponse: false,
    cartHeader: {
        Price: 0.0
    },
    internetSectionSubTotal: 0.0,
    phoneSectionSubTotal: 0.0,
    tvSectionSubTotal: 0.0,
    oneTimeChargesSubTotal: 0.0,
    totalTaxAmount: 0.0,
    internet: {},
    phone: {},
    tv: {},
    voice: {}
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_IS_API_RESPONSE':
            return { ...state, isAPIResponse: action.data }
        case 'UPDATE_SELECTED_PHONE_SERVICE_IN_STATE':
            return { ...state, phoneServiceInfo: action.data }
        case 'UPDATE_DIRECTORY_LISTING_IN_STATE':
            return { ...state, listingInfo: action.data }
        case 'UPDATE_BDV_FAXLINE_IN_STATE':
            return { ...state, faxLineInfo: action.data }
        case 'UPDATE_N_LINES_IN_STATE':
            return { ...state, lines: action.data } 
        case 'UPDATE_EQUIPMENTS_IN_STATE':
            return { ...state, equipments: action.data } 
        case 'UPDATE_TV_PLAN_IN_STATE':
            return { ...state, tvPlan: action.data }
        case 'UPDATE_PREM_CHANNELS_IN_STATE':
            return { ...state, premChannels: action.data }
        case 'UPDATE_TV_EQUIPMENT_IN_STATE':
            return { ...state, tvEquip: action.data }
        case 'UPDATE_TV_RECORDING_IN_STATE':
            return { ...state, tvRec: action.data }
        case 'UPDATE_CART_HEADER_SECTION':
            return { ...state, cartHeader: action.data }
        case 'UPDATE_INTERNET_SECTION':
            return { ...state, internetSection: action.data }
        case 'UPDATE_PHONE_SECTION':
            return { ...state, phoneSection: action.data }
        case 'UPDATE_TV_SECTION':
            return { ...state, tvSection: action.data }
        case 'UPDATE_ONE_TIME_CHARGES_SECTION':
            return { ...state, oneTimeCharges: action.data }
        case 'UPDATE_TAX_SECTION':
            return { ...state, totalTaxAmount: action.data }
        case 'UPDATE_UPCOMING_MONTHS_SECTION':
            return { ...state, upcomingMonthlyCharges: action.data }
        case 'UPDATE_INTERNET_SECTION_SUB_TOTAL':
            return { ...state, internetSectionSubTotal: action.data }
        case 'UPDATE_PHONE_SECTION_SUB_TOTAL':
            return { ...state, phoneSectionSubTotal: action.data }
        case 'UPDATE_TV_SECTION_SUB_TOTAL':
            return { ...state, tvSectionSubTotal: action.data }
        case 'UPDATE_ONE_TIME_CHARGES_SECTION_SUB_TOTAL':
            return { ...state, oneTimeChargesSubTotal: action.data }
        case 'UPDATE_INTERNET_PLAN_IN_STATE':
            return { ...state, internetPlan: action.data }
        case 'UPDATE_INTERNET_IP_IN_STATE':
            return { ...state, internetIP: action.data }
        case "UPDATE_PHONE_LINES":
            return { ...state, 
                phoneSection: { ...state.phoneSection, lineLevel: action.data.lineLevel, title: action.data?.title},
                cartHeader: { ...state.cartHeader, PhoneTitle: action.data?.title}
            }
        case "UPDATE_PHONE_TYPE_SELECTION":
            return { ...state,
                cartHeader: { ...state.cartHeader,
                    PhoneTitle: action.data.value,
                    Price: Number(action.data.selectedPrice)}
            }
        case "UPDATE_FAX_LINES":
            return { ...state,
                phoneSection: { ...state.phoneSection, FaxLine: action.data}
            }
        case "UPDATE_DIR_LISTING_FCART":
            return { ...state,
            phoneSection: {...state.phoneSection, accountLevel: action.data}
            }
        case "UPDATE_INTERNET_CART_SELECTION":
            return { ...state,
            internet: action.data
        }
        case "UPDATE_PHONE_CART_SELECTION":
            return { ...state,
            phone: action.data
        }
        case "UPDATE_VOICE_CART_SELECTION":
            return { ...state,
            voice: action.data 
        }
        case "UPDATE_TV_CART_SELECTION":
            return { ...state,
            tv: action.data
        }
        case "RESET_CART_SELECTION":
            return { ...state,
            internet: {},
            phone: {},
            tv: {},
            voice: {}
        }
        case "TOGGLE_LOADING_SPINNER_FLOATING_CART":
            return { ...state, toggleSpinnerInFloatingCart: action.data }
        case "FLOATING_CART_LOADING_SPINNER":
            return { ...state, floatingCartLoader: action.data }
        case "UPDATE_ADDITIONAL_CORDLESS":
            return { ...state, updateAdditionalCordless: action.data } 
        case "DISABLE_UPDATE_CORDLESS_BASE":
            return { ...state, disableUpdateCordlessBase: action.data }    
        default:
            return state;
    }
};

export default reducer;